"use client";

import { useText } from "@/app/(site)/europe/useTranslations";
import { EuStarRing } from "./EuStarRing";
import { MdrBackdrop } from "./MdrBackdrop";
import { MdrLeadForm } from "./MdrLeadForm";
import css from "./mdr-section.module.scss";

/**
 * "Launch your own MDR-certified device in Europe" — the blue tile that closes
 * the certification block on the EU lander.
 *
 * It keeps the mockup's composition (eyebrow and rule, three-line headline and
 * standfirst on the left; star ring over a two-field form on the right) but sets
 * the type on the site's own scale: the mockup draws the headline near 86px,
 * where the site's `h2` is 64px, the same gap the Figma buttons have against
 * `$btn-font-size`. Matching the drawing here would leave this one headline
 * larger than every other h2 on the page.
 */
export const EuropeanLanderMdrSection = () => {
  const eyebrow = useText("mdr.eyebrow");
  const headline = useText("mdr.headline");
  const body = useText("mdr.body");

  return (
    <section className={css["section"]}>
      <div className={css["tile"]}>
        <MdrBackdrop />

        <div className={css["copy"]}>
          <p className={css["eyebrow"]}>{eyebrow}</p>
          <h2 className={css["headline"]}>{headline}</h2>
          <p className={css["body"]}>{body}</p>
        </div>

        <div className={css["panel"]}>
          <EuStarRing className={css["stars"]} />
          <MdrLeadForm />
        </div>
      </div>
    </section>
  );
};
